export enum TabId {
    EVENTS = 'events',
    ATTRIBUTES = 'attributes',
    CHANGE_REQUESTS = 'change-requests',
}

export enum TabCaption {
    EVENTS = 'Events',
    ATTRIBUTES = 'Attributes',
    CHANGE_REQUESTS = 'Change Requests',
}

export type TabItem = {
    caption: TabCaption,
    tabId: TabId,
    count?: number,
};
